webpackJsonp([275134419026451],{

/***/ 1220:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CensusKennelStatus","kind":"ENUM","type":"OBJECT","fields":null,"description":null,"enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"CLEAN"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"DIRTY"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"DO_NOT_USE"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"STORAGE"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-census-kennel-status-ca654a126b97fb64f7ff.js